import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { MultiSetsMulticampaignPromotionModule, MultiSetsMulticampaignPromotionModuleEvents } from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionDisabledState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    public onEnterState(): void {
        this.emit('General.UI.ENABLE', MultiSetsMulticampaignPromotionModule.NAME);
    }
    public onLeaveState(): void {}
    protected setupEvents(): void {}
}
